import * as React from "react"

import { cn } from "../lib/utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm transition-all placeholder:text-muted-foreground placeholder:font-normal focus-visible:outline-none focus:outline-none focus-visible:border-foreground focus:border-foreground focus-visible:ring-2 focus:ring-2 focus-visible:ring-ring focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm touch-manipulation",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }